import { useQuery } from '@tanstack/react-query';

import { api } from '../api/client';
import type { FeedCategory, FeedSeverity } from '../api/types';

interface UseEventFeedFilters {
  severity?: FeedSeverity[] | undefined;
  categories?: FeedCategory[] | undefined;
}

/** Phase 6.9 C2 — poll the curated «Лента событий». 5 s refresh,
 *  matching the Logs/Feed cadence so cross-screen state stays in
 *  sync. `enabled=false` (e.g. when every severity toggle is off)
 *  parks the query without issuing a request. */
export function useEventFeed(
  filters: UseEventFeedFilters,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ['event-feed', filters],
    queryFn: () => api.listEventFeed(filters),
    refetchInterval: 5000,
    staleTime: 2000,
    enabled: options?.enabled ?? true,
  });
}
